"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondaryTooltip = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _dropdown = require("../../dropdown");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SecondaryTooltip = function SecondaryTooltip(props) {
  var children = props.children,
      dropdownProps = props.dropdownProps,
      content = props.content,
      forcedActive = props.forcedActive;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      innerActive = _useState2[0],
      setInnerActive = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      customOffsetLeft = _useState4[0],
      setCustomOffsetLeft = _useState4[1];

  var childRef = (0, _react.useRef)(null);

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      containerNode = _useState6[0],
      setContainerNode = _useState6[1];

  var contentRef = (0, _react.useCallback)(function (node) {
    if (node) setContainerNode(node);
  }, []);
  var dropdownRef = (0, _react.useRef)(null);
  var active = forcedActive === null ? innerActive : forcedActive;
  var onOpenHandler = (0, _react.useCallback)(function () {
    setInnerActive(true);
  }, []);
  var onCloseHandler = (0, _react.useCallback)(function () {
    setInnerActive(false);
  }, []);
  var onMouseEnterHandler = (0, _react.useCallback)(function (event) {
    var childNode = childRef.current;
    var dropdownNode = dropdownRef.current;
    if (event.target === childNode && event.fromElement === dropdownNode) return;
    if (event.target === dropdownNode) return;
    onOpenHandler();
  }, [onOpenHandler]);
  var onMouseLeaveHandler = (0, _react.useCallback)(function (event) {
    var childNode = childRef.current;
    var dropdownNode = dropdownRef.current;
    if (event.target === childNode && event.toElement === dropdownNode) return;
    if (event.target === dropdownNode && event.toElement === childNode) return;
    onCloseHandler();
  }, [onCloseHandler]);
  var clonedChild = (0, _react.useMemo)(function () {
    return /*#__PURE__*/(0, _react.cloneElement)(children, {
      ref: childRef
    });
  }, [children]);
  var clonedContent = (0, _react.useMemo)(function () {
    return /*#__PURE__*/(0, _react.cloneElement)( /*#__PURE__*/_react.default.createElement("div", null, content), {
      ref: contentRef
    });
  }, [content, contentRef]);
  (0, _react.useEffect)(function () {
    var childNode = childRef.current;
    var dropdownNode = dropdownRef.current;
    childNode.addEventListener('mouseenter', onMouseEnterHandler);
    childNode.addEventListener('mouseleave', onMouseLeaveHandler);

    if (dropdownNode) {
      dropdownNode.addEventListener('mouseenter', onMouseEnterHandler);
      dropdownNode.addEventListener('mouseleave', onMouseLeaveHandler);
    }

    return function () {
      childNode.removeEventListener('mouseenter', onMouseEnterHandler);
      childNode.removeEventListener('mouseleave', onMouseLeaveHandler);

      if (dropdownNode) {
        dropdownNode.removeEventListener('mouseenter', onMouseEnterHandler);
        dropdownNode.removeEventListener('mouseleave', onMouseLeaveHandler);
      }
    };
  }, [onCloseHandler, onOpenHandler, children, onMouseEnterHandler, onMouseLeaveHandler, active]);
  var tooltipScale = (0, _react.useRef)();

  if (dropdownRef.current) {
    tooltipScale.current = getComputedStyle(dropdownRef.current).getPropertyValue('--tooltip-scale');
  }

  (0, _react.useEffect)(function () {
    if (containerNode && childRef.current) {
      var contentRect = containerNode.getBoundingClientRect();
      var childRect = childRef.current.getBoundingClientRect();
      setCustomOffsetLeft((childRect.width - (contentRect.width / tooltipScale.current + 40)) / 2);
    }
  }, [containerNode, childRef]);

  var dropdown = /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, {
    ref: dropdownRef,
    variation: "secondary",
    view: "tooltip",
    active: active,
    onOverlayClick: function onOverlayClick() {},
    dropdownCoreProps: _objectSpread(_objectSpread({}, dropdownProps), {}, {
      customOffsetLeft: customOffsetLeft,
      animated: true
    })
  }, clonedContent);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dropdownProps.direction === 'up' ? dropdown : null, clonedChild, dropdownProps.direction !== 'up' ? dropdown : null);
};

exports.SecondaryTooltip = SecondaryTooltip;
SecondaryTooltip.propTypes = {
  /* component logic props */
  children: _propTypes.element.isRequired,
  content: _propTypes.node.isRequired,
  dropdownProps: _propTypes.object,
  forcedActive: _propTypes.bool
  /* styling modificators */

  /* classes */

};
SecondaryTooltip.defaultProps = {
  dropdownProps: {},
  forcedActive: null
};